/* I am a webpack entry! */

import Vue from 'vue';
import App from './App.vue';

import '@cdn_css/index.scss';

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App)
}).$mount('#app');
